import { useState, useEffect } from 'react'
import { useAuth } from '../contexts/AuthContext'

export const useSettings = () => {
  const { user, isLoading, isAuthenticated, getCurrentUser } = useAuth()
  const [currentUser, setCurrentUser] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchUser = async () => {
      try {
        if (isAuthenticated && user) {
          setCurrentUser(user)
        } else if (isAuthenticated) {
          const userData = await getCurrentUser()
          setCurrentUser(userData)
        }
      } catch (error) {
        if (process.env.NODE_ENV === 'development') console.error('Failed to fetch user data:', error)
      } finally {
        setLoading(false)
      }
    }

    if (!isLoading) {
      fetchUser()
    }
  }, [isAuthenticated, user, isLoading, getCurrentUser])

  const handleUserUpdate = (updatedUser) => {
    setCurrentUser(updatedUser)
  }

  return {
    currentUser,
    loading: loading || isLoading,
    isAuthenticated,
    handleUserUpdate
  }
}